import { type ReactNode } from "react";
import { createPortal } from "react-dom";
import { useMapLayout } from "./useMapLayout";
import { REGION_IDS } from "./constants";

interface HeaderSlotProps {
  children: ReactNode;
}

/**
 * MapLayout.HeaderLeft - Portals content to the left side of the header.
 */
export function HeaderLeft({ children }: HeaderSlotProps) {
  const { mounted } = useMapLayout();

  if (!mounted) return null;

  const target = document.getElementById(REGION_IDS.headerLeft);
  if (!target) return null;

  return createPortal(<>{children}</>, target);
}

/**
 * MapLayout.HeaderRight - Portals content to the right side of the header.
 */
export function HeaderRight({ children }: HeaderSlotProps) {
  const { mounted } = useMapLayout();

  if (!mounted) return null;

  const target = document.getElementById(REGION_IDS.headerRight);
  if (!target) return null;

  return createPortal(<>{children}</>, target);
}
